import React from 'react';
import { SwapHero } from './SwapHero';
import { SwapForm } from '../SwapForm';
import { SwapStatusAlerts } from './SwapStatusAlerts';
import { SwapActionButton } from './SwapActionButton';
import { TransactionStatus } from './TransactionStatus';
import { ProofStrip } from './ProofStrip';

export const SwapCard = ({
  // SwapForm props
  selectedStablecoin,
  onSelectStablecoin,
  stablecoins,
  stablecoinBalance,
  usdnBalance,
  balanceLabel,
  amount,
  onAmountChange,
  inputError,
  isConnected,
  onMaxClick,
  stablecoinLoading,
  usdnLoading,

  // Alerts props
  isWalletNetworkAligned,
  selectedChainKey,
  selectedChain,
  chainReadinessMessage,

  // Action Button props
  capabilities,
  allowanceEnough,
  isLoading,
  isDisabled,
  buttonText,
  onConnectOrSwap,

  // Status & Transaction props
  status,
  statusType,
  transactionHash,
  pendingSwapHash,
  pendingSwapClearLabel,
  onClearPendingSwap,
}) => {
  return (
    <main className="main" role="main">
      <div className="hero-backdrop" aria-hidden="true">
        <img src="/nova-hero.png" alt="" className="hero-glow" />
        <img src="/nova-starburst.svg" alt="" className="hero-mark" />
      </div>

      <section className="swap-container" aria-labelledby="swap-title">
        <SwapHero />

        <SwapForm
          selectedStablecoin={selectedStablecoin}
          onSelectStablecoin={onSelectStablecoin}
          stablecoins={stablecoins}
          stablecoinBalance={stablecoinBalance}
          usdnBalance={usdnBalance}
          balanceLabel={balanceLabel}
          amount={amount}
          onAmountChange={onAmountChange}
          inputError={inputError}
          isConnected={isConnected}
          onMaxClick={onMaxClick}
          stablecoinLoading={stablecoinLoading}
          usdnLoading={usdnLoading}
        />

        <SwapStatusAlerts
          isConnected={isConnected}
          isWalletNetworkAligned={isWalletNetworkAligned}
          selectedChainKey={selectedChainKey}
          selectedChain={selectedChain}
          chainReadinessMessage={chainReadinessMessage}
        />

        <div className="swap-actions">
          <SwapActionButton
            isConnected={isConnected}
            isWalletNetworkAligned={isWalletNetworkAligned}
            requiresApproval={capabilities?.requiresApproval}
            allowanceEnough={allowanceEnough}
            isLoading={isLoading}
            isDisabled={isDisabled}
            buttonText={buttonText}
            onClick={onConnectOrSwap}
          />

          <TransactionStatus
            status={status}
            statusType={statusType}
            selectedChainKey={selectedChainKey}
            transactionHash={transactionHash}
            pendingSwapHash={pendingSwapHash}
            pendingSwapClearLabel={pendingSwapClearLabel}
            onClearPendingSwap={onClearPendingSwap}
          />
        </div>
      </section>

      <ProofStrip />
    </main>
  );
};
